import {
  CLEAR_RECEIPTS_DATA,
  STORE_RECEIPTS_DATA,
  UPLOAD_PROVISIONAL_RECEIPT,
  UPLOAD_PROVISIONAL_RECEIPT_SUCCESS,
  UPLOAD_PROVISIONAL_RECEIPT_ERROR,
  DOWNLOAD_PROVISIONAL_RECEIPT,
  DOWNLOAD_PROVISIONAL_RECEIPT_SUCCESS,
  DOWNLOAD_PROVISIONAL_RECEIPT_ERROR,
  GET_PROVISIONAL_RECEIPTS,
  GET_PROVISIONAL_RECEIPTS_SUCCESS,
  SUBMIT_RECEIPTS,
  SUBMIT_RECEIPTS_SUCCESS,
  RESET_SUBMIT_RECEIPTS_SUCCESS,
  SUBMIT_RECEIPTS_ERROR,
  DELETE_PROVISIONAL_RECEIPT,
  DELETE_PROVISIONAL_RECEIPT_SUCCESS,
  RESET_DELETE_RECEIPT_SUCCESS,
  GET_PROVISIONAL_RECEIPTS_BY_FILTER,
  GET_PROVISIONAL_RECEIPTS_BY_FILTER_SUCCESS,
  GET_PROVISIONAL_RECEIPTS_BY_FILTER_ERROR,
  EXPORT_PROVISIONAL_RECEIPTS,
  EXPORT_PROVISIONAL_RECEIPTS_SUCCESS,
  EXPORT_PROVISIONAL_RECEIPTS_ERROR,
  RESEND_PROVISIONAL_RECEIPT_EMAIL,
  RESEND_PROVISIONAL_RECEIPT_EMAIL_SUCCESS,
  RESEND_PROVISIONAL_RECEIPT_EMAIL_ERROR,
  GET_PROVISIONAL_RECEIPT_BY_ID,
  GET_PROVISIONAL_RECEIPT_BY_ID_SUCCESS,
  GET_PROVISIONAL_RECEIPT_BY_ID_ERROR,
  CLEAR_SELECTED_PROVISIONAL_RECEIPT,
} from '../constants/ActionsTypes'

export const uploadReceipt = (params) => {
  return {
    type: UPLOAD_PROVISIONAL_RECEIPT,
    payload: params,
  }
}

export const uploadReceiptSuccess = (data) => {
  return {
    type: UPLOAD_PROVISIONAL_RECEIPT_SUCCESS,
    payload: data,
  }
}

export const uploadReceiptError = (error) => {
  return {
    type: UPLOAD_PROVISIONAL_RECEIPT_ERROR,
    payload: error,
  }
}

export const storeReceiptsData = (receiptsData, operation) => ({
  type: STORE_RECEIPTS_DATA,
  payload: receiptsData,
  operation,
})

export const clearReceiptsData = () => {
  return {
    type: CLEAR_RECEIPTS_DATA,
  }
}

export const getProvisionalReceipts = () => {
  return {
    type: GET_PROVISIONAL_RECEIPTS,
  }
}

export const getProvisionalReceiptsSuccess = (data) => {
  return {
    type: GET_PROVISIONAL_RECEIPTS_SUCCESS,
    payload: data,
  }
}

export const submitReceipts = (params) => {
  return {
    type: SUBMIT_RECEIPTS,
    payload: params,
  }
}

export const submitReceiptsSuccess = (data) => {
  return {
    type: SUBMIT_RECEIPTS_SUCCESS,
    payload: data,
  }
}

export const submitReceiptsError = (error) => {
  return {
    type: SUBMIT_RECEIPTS_ERROR,
    payload: error,
  }
}

export const resetSubmitReceiptsSuccess = () => ({
  type: RESET_SUBMIT_RECEIPTS_SUCCESS,
})

export const deleteReceipt = (params) => {
  return {
    type: DELETE_PROVISIONAL_RECEIPT,
    payload: params,
  }
}

export const deleteReceiptSuccess = (data) => {
  return {
    type: DELETE_PROVISIONAL_RECEIPT_SUCCESS,
    payload: data,
  }
}

export const resetDeleteReceiptSuccess = () => ({
  type: RESET_DELETE_RECEIPT_SUCCESS,
})

export const getProvisionalReceiptsByFilter = (params) => ({
  type: GET_PROVISIONAL_RECEIPTS_BY_FILTER,
  payload: params,
})

export const getProvisionalReceiptsByFilterSuccess = (data) => ({
  type: GET_PROVISIONAL_RECEIPTS_BY_FILTER_SUCCESS,
  payload: data,
})

export const getProvisionalReceiptsByFilterError = (error) => ({
  type: GET_PROVISIONAL_RECEIPTS_BY_FILTER_ERROR,
  payload: error,
})

export const exportProvisionalReceipts = (params) => ({
  type: EXPORT_PROVISIONAL_RECEIPTS,
  payload: params,
})

export const exportProvisionalReceiptsSuccess = () => ({
  type: EXPORT_PROVISIONAL_RECEIPTS_SUCCESS,
})

export const exportProvisionalReceiptsError = (error) => ({
  type: EXPORT_PROVISIONAL_RECEIPTS_ERROR,
  payload: error,
})

export const resendProvisionalReceiptEmail = (id) => ({
  type: RESEND_PROVISIONAL_RECEIPT_EMAIL,
  payload: id,
})

export const resendProvisionalReceiptEmailSuccess = () => ({
  type: RESEND_PROVISIONAL_RECEIPT_EMAIL_SUCCESS,
})

export const resendProvisionalReceiptEmailError = (error) => ({
  type: RESEND_PROVISIONAL_RECEIPT_EMAIL_ERROR,
  payload: error,
})

export const downloadProvisionalReceipt = (payload) => ({
  type: DOWNLOAD_PROVISIONAL_RECEIPT,
  payload,
})

export const downloadProvisionalReceiptSuccess = () => ({
  type: DOWNLOAD_PROVISIONAL_RECEIPT_SUCCESS,
})

export const downloadProvisionalReceiptError = (error) => ({
  type: DOWNLOAD_PROVISIONAL_RECEIPT_ERROR,
  payload: error,
})

export const getProvisionalReceiptById = (id) => ({
  type: GET_PROVISIONAL_RECEIPT_BY_ID,
  payload: id,
})

export const clearSelectedProvisionalReceipt = () => ({
  type: CLEAR_SELECTED_PROVISIONAL_RECEIPT,
})

export const getProvisionalReceiptByIdSuccess = (data) => ({
  type: GET_PROVISIONAL_RECEIPT_BY_ID_SUCCESS,
  payload: data,
})

export const getProvisionalReceiptByIdError = (error) => ({
  type: GET_PROVISIONAL_RECEIPT_BY_ID_ERROR,
  payload: error,
})
